var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.status!="approved" && _vm.item.status)?_c('ui-chip',{attrs:{"icon":"exclamation-circle","backgroundColor":_vm.getStatusColor(_vm.item.status)}},[_vm._v(" "+_vm._s(_vm.$t('language.'+_vm.item.status))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }